import React from 'react';
import SettingsTab from '../components/SettingsTab';

export default function Settings() {
  return <SettingsTab />;
}